export const manageBodyOverflow = (isOpen: boolean): void => {
  if (isOpen) {
    document.body.style.overflow = 'hidden';
  }
};

export const cleanupBodyOverflow = (): void => {
  document.body.style.overflow = '';
};

export const handleModalClose = (options: {
  hasUnsavedChanges: boolean;
  isComplete: boolean;
  onShowConfirmation: () => void;
  onClose: () => void;
}): void => {
  if (options.hasUnsavedChanges && !options.isComplete) {
    options.onShowConfirmation();
  } else {
    options.onClose();
  }
};

export const getDefaultConfirmationData = () => ({
  title: 'Discard changes?',
  message: 'You have unsaved changes. Are you sure you want to close without saving?',
  confirmText: 'Discard',
  cancelText: 'Cancel',
});
